export default __webpack_public_path__ + "static/media/template-blank.481dd9b2.png";